import { Tooltip, Typography } from '@material-ui/core';
import { WithStyles } from 'decorators/withStyles';
import { IProduct, IProductOrderBump } from 'interfaces/orderbump';
import React, { PureComponent } from 'react';

interface IProps {
  classes?: any;
  product: IProductOrderBump;
  onClick: (productOrderBump: IProductOrderBump) => void;
}

interface IState {}

@WithStyles(() => ({
  root: {
    border: '1px solid #ced4da',
    borderRadius: 4,
    margin: '4px 0'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '15px 15px',
    '&#children-product': {
      paddingLeft: 32
    }
  },
  rowChildren: {
    marginLeft: '20px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '15px 15px',
    '&#children-product': {
      paddingLeft: 32
    }
  },
  label: {
    color: '#565662',
    fontSize: '0.875rem'
  }
}))
export default class RowListBump extends PureComponent<IProps, IState> {
  render() {
    const { product, onClick } = this.props;
    const { row, label, root, rowChildren } = this.props.classes;
    const styleValidBump = (orderbump: IProduct) =>
      !orderbump.validToBump ? { cursor: 'default' } : { cursor: 'pointer' };
    const componentValid = (orderbump: IProduct) =>
      !orderbump.validToBump ? (
        <Tooltip title={orderbump.errorMsg}>
          <Typography variant="body1" className={label} style={{ color: '#f44336' }}>
            {`${orderbump.id} - ${orderbump.title}`}
          </Typography>
        </Tooltip>
      ) : (
        <Typography variant="body1" className={label}>
          {`${orderbump.id} - ${orderbump.title}`}
        </Typography>
      );

    return (
      <div className={root}>
        <div
          key={product.id}
          style={styleValidBump(product)}
          className={row}
          onClick={!product.validToBump ? null : () => onClick(product)}
        >
          {componentValid(product)}
        </div>
        {!!product.children &&
          product.children.length > 0 &&
          product.children.map((children: any) => (
            <div
              key={children.id}
              style={styleValidBump(children)}
              className={rowChildren}
              onClick={!children.validToBump ? null : () => onClick(children)}
            >
              {componentValid(children)}
            </div>
          ))}
      </div>
    );
  }
}
